import { render, staticRenderFns } from "./GoogleApiHistories.vue?vue&type=template&id=1438c018&scoped=true"
import script from "./GoogleApiHistories.vue?vue&type=script&lang=js"
export * from "./GoogleApiHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438c018",
  null
  
)

export default component.exports